import React, { MouseEvent, useState } from 'react'
import Grid from '@mui/material/Grid'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import { AvatarInfo, Paragraph } from 'components/shared'
import { useDropdownStyles } from '../TaskAside.style'

export interface IUserOption {
  id: number
  title: string
  avatar: string
  firstName: string
  lastName: string
  online?: boolean
  roles?: any
}

interface IUserDropdown {
  value: IUserOption | null
  list: IUserOption[]
  onChange: (id: number) => void
}

const UserDropdown = (props: IUserDropdown) => {
  const { value, list, onChange } = props
  const classes = useDropdownStyles({})
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleClick = (event: MouseEvent<any>) => {
    if (list.length >= 2) setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleItemClick = (id: number) => {
    setAnchorEl(null)
    onChange(id)
  }

  return (
    <>
      {value && (
        <AvatarInfo
          size={'md'}
          avatar={value.avatar}
          storage={false}
          grayscale
          firstName={value.firstName}
          lastName={value.lastName}
        >
          <button onClick={handleClick}>
            <Grid container alignItems={'center'} wrap={'nowrap'}>
              <Grid item>
                <Paragraph size={'sm'} weight={'bold'} align={'left'}>
                  {value.firstName} {value.lastName}
                </Paragraph>
              </Grid>
              {list.length >= 2 && (
                <Grid item>
                  <svg width="16px" height="16px" style={{ display: 'block' }}>
                    <use xlinkHref="#triangle" />
                  </svg>
                </Grid>
              )}
            </Grid>
          </button>
          <Paragraph className={'grey'} size={'sm'}>
            {value.title}
          </Paragraph>
        </AvatarInfo>
      )}
      <Menu
        classes={{
          paper: classes.paper,
        }}
        style={{ zIndex: 10000 }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        // getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        MenuListProps={
          {
            // TODO
            // onMouseLeave: handleClose,
          }
        }
        PaperProps={{
          elevation: 4,
        }}
      >
        {list.map(({ id, firstName, lastName }) => (
          <MenuItem key={id} disableRipple onClick={() => handleItemClick(id)}>
            <span data-id={`menuitem_${id}`}>
              {firstName} {lastName}
            </span>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default UserDropdown
